import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthModalService } from '../../../services/auth-modal.service';
import { PurchaseStateService } from '../../../services/purchase-state.service';
import { SessionService } from '../../../services/session.service';
import { IzipayCheckoutComponent } from '../../izipay-checkout/izipay-checkout';
import { IzipayResult } from '../../../models/izipay.model';

@Component({
  selector: 'app-modal-payment-method',
  imports: [IzipayCheckoutComponent],
  templateUrl: './modal-payment-method.component.html',
  styleUrl: './modal-payment-method.component.scss',
  styles: `.payment-modal { width: 100%; height: auto; max-height: calc(100dvh - 32px); overflow-y: auto; padding: 24px 12px; } app-izipay-checkout { display: block; width: 100%; }`,
})
export class ModalPaymentMethodComponent {
  readonly modal = inject(AuthModalService);
  readonly purchase = inject(PurchaseStateService);
  private readonly session = inject(SessionService);
  private readonly router = inject(Router);
  get totalAmount() { return this.purchase.total(); }

  onPaid(result: IzipayResult): void {
    const items = this.purchase.items();
    const user = this.session.usuario();
    this.modal.close();
    this.router.navigate(['/checkout/confirmation'], { state: {
      orderId: result.orderId, monto: result.amount,
      entradas: items.map(item => ({ nombre: item.sector.nombre, cantidad: item.cantidad, precio: item.sector.precio })),
      titular: user ? [user.nombre, user.apellido].join(' ').trim() : 'Cliente',
      metodoPago: 'Izipay',
    } });
  }
}
